import Vue from 'vue'
import Vuex from 'vuex'
// 按需导入 API 方法
import { getUserCustomerAPI } from '@/api/user'

Vue.use(Vuex)

let initState = {
  // 用来存储 tokenCustomer 信息的对象，将来这个对象中会包含两个属性 { token, refresh_token }
  tokenCustomer: {
    token: ''
  },
  // 用户的基本信息
  userCustomer: {
    userName: ''
  }
}
const stateStr = localStorage.getItem('state')
if (stateStr) {
  // 加载本地的数据
  initState = JSON.parse(stateStr)
}

export default new Vuex.Store({
  state: initState,
  getters: {
  },
  mutations: {
    // 更新tokenCustomer数据的方法
    updateTokenCustomer (state, payload) {
      state.tokenCustomer = payload
      this.commit('saveStateToStorage')
    },
    // 将state持久化存储到本地
    saveStateToStorage (state) {
      localStorage.setItem('state', JSON.stringify(state))
    },
    // 更新 userCustomer 的方法
    updateUserCustomer (state, payload) {
      state.userCustomer = payload
      this.commit('saveStateToStorage')
    },
    // 清空 vuex 和本地的数据
    cleanState (state) {
      // 1. 清空 vuex 中的数据
      state.tokenCustomer = {
        token: ''
      }
      state.userCustomer = {
        userName: ''
      }
      // 2. 将清空后的 state 存储到本地
      this.commit('saveStateToStorage')
    }
  },
  actions: {
    // 初始化用户的基本信息
    async initUserCustomer (ctx) {
      const { data: res } = await getUserCustomerAPI(initState.tokenCustomer.token)
      if (res.message === 'OK') {
        ctx.commit('updateUserCustomer', res.data)
      }
    }
  },
  modules: {
  }
})
